// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert-message-module__alert--iCw5x {
  position: absolute;
  z-index: 999999;
  top: 58px;
  width: 600px;
  text-align: center;
  display: flex;
  justify-content: center;
  position: fixed;
}
.alert-message-module__alertError--mMZYr {
  color: #d32f2f !important;
  background-color: rgb(227 4 4 / 25%) !important;
}
.alert-message-module__alertSuccess--lsxqN {
  color: #2e7d32 !important;
  background-color: rgb(68 134 16 / 25%) !important;
}

@media (max-width: 780px) {
  .alert-message-module__alert--iCw5x {
    width: 300px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/shared/alert-message/alert-message.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;AACA;EAEE,yBAAyB;EACzB,+CAA+C;AACjD;AACA;EAEE,yBAAyB;EACzB,iDAAiD;AACnD;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".alert {\r\n  position: absolute;\r\n  z-index: 999999;\r\n  top: 58px;\r\n  width: 600px;\r\n  text-align: center;\r\n  display: flex;\r\n  justify-content: center;\r\n  position: fixed;\r\n}\r\n.alertError {\r\n  composes: alert;\r\n  color: #d32f2f !important;\r\n  background-color: rgb(227 4 4 / 25%) !important;\r\n}\r\n.alertSuccess {\r\n  composes: alert;\r\n  color: #2e7d32 !important;\r\n  background-color: rgb(68 134 16 / 25%) !important;\r\n}\r\n\r\n@media (max-width: 780px) {\r\n  .alert {\r\n    width: 300px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alert": `alert-message-module__alert--iCw5x`,
	"alertError": `alert-message-module__alertError--mMZYr alert-message-module__alert--iCw5x`,
	"alertSuccess": `alert-message-module__alertSuccess--lsxqN alert-message-module__alert--iCw5x`
};
export default ___CSS_LOADER_EXPORT___;
